<div class="">

    <div *ngIf="canViewMenu" class="allFAQS" [formGroup]="mealSelections" name="mealform">
        <div *ngIf="!isLastDayOfCruise" class="btn-container">
            <!-- <span *ngIf="!isPastCuttoffWindow">Please submit your lunch and dinner preferences prior to {{displayedCutoffTime}}.</span> -->
            <span *ngIf="!isPastCuttoffWindow">Please submit your lunch and dinner preferences prior to
                {{displayedcutofftime}}.</span>
            <div class="tenpxtop"></div>

        </div>
        <!-- LUNCH ENTREE -->
        <ng-container *ngIf="!this.isLastDayOfCruise && !this.lunchover">
            <ng-container>
                <div class="mealtype">
                    <app-longgoldbar></app-longgoldbar>
                    <!-- Skips over Lunch Dessert if everyone on the edit page is opting out of lunch -->
                    <div>Lunch</div>
                    <div><span class="mealtime">{{lunchstarttime | timepipe}} - {{lunchendtime |
                            timepipe}}</span></div>

                </div>
            </ng-container>
            <ng-container *ngFor="let menuItem of LunchEntreeMenuItems; let i=index;">
                <ng-container>
                    <div class="tenpxtop"></div>
                    <div class="mealname">{{menuItem.micName}}</div>
                    <div class="mealdesc" *ngIf="menuItem.micGuestDescription!=undefined">
                        -{{menuItem.micGuestDescription}}</div>
                </ng-container>
                <ng-container *ngIf="!isEmployeeOrCrewMember">
                    <div *ngFor="let guest of bookedGuests; let j=index;">
                        <ng-container
                            *ngIf="mealSelections.controls[j + 'lunchAshore'].value === false && mealSelections.controls[j + 'lunchCafe'].value === false">
                            <input type="checkbox"
                                [formControl]="$any(mealSelections).controls[j + 'lunchEntree' + menuItem.micuid]">
                            <span class="passenger-name"
                                [ngClass]="{'disabled': mealSelections.disabled}">{{bookedGuests[j].folFullNameSal}}</span>

                            <div *ngIf="mealSelections.controls[j + 'lunchEntree' + menuItem.micuid].value === true"
                                class="half-portion">
                                <input type="checkbox"
                                    [formControl]="$any(mealSelections).controls[j + 'lunchEntree' + menuItem.micuid + 'HalfPortion']">
                                <span class="selection-text" [ngClass]="{'disabled': mealSelections.disabled}">1/2
                                    Portion
                                    entr&eacute;e</span>
                            </div>
                        </ng-container>


                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
        <!-- LUNCH OPT OUT  -->
        <ng-container *ngIf="!this.isLastDayOfCruise && !isEmployeeOrCrewMember && !this.lunchover">
            <div class="tenpxtop"></div>
            <span class="selection-text lunch-text">I will be dining ashore for lunch.</span>
            <div *ngFor="let guest of bookedGuests; let j=index;">
                <ng-container *ngIf="mealSelections.controls[j + 'lunchCafe'].value === false">
                    <input type="checkbox" [formControl]="$any(mealSelections).controls[j + 'lunchAshore']">
                    <span class="passenger-name"
                        [ngClass]="{'disabled': mealSelections.disabled}">{{bookedGuests[j].folFullNameSal}}</span>
                </ng-container>
            </div>
            <ng-container *ngIf="cafeName.length > 0">
                <div class="tenpxtop"></div>
                <span class="selection-text lunch-text">I will be dining at the {{cafeName}} for lunch.</span>
                <div *ngFor="let guest of bookedGuests; let j=index;">
                    <ng-container *ngIf="mealSelections.controls[j + 'lunchAshore'].value === false">
                        <input type="checkbox" [formControl]="$any(mealSelections).controls[j + 'lunchCafe']">
                        <span class="passenger-name"
                            [ngClass]="{'disabled': mealSelections.disabled}">{{bookedGuests[j].folFullNameSal}}</span>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>
        <div class="tenpxtop"></div>
        <!-- Dinner Appetizer -->
        <ng-container *ngIf="!this.isLastDayOfCruise">
            <ng-container>
                <div class="mealtype">
                    <app-longgoldbar></app-longgoldbar>
                    <div>Dinner Appetizer</div>
                    <div><span class="mealtime">{{dinnerstarttime | timepipe}} - {{dinnerendtime |
                            timepipe}}</span></div>

                </div>
            </ng-container>
            <ng-container *ngFor="let menuItem of DinnerAppetizerMenuItems; let i=index;">
                <ng-container>
                    <div class="tenpxtop"></div>
                    <div class="mealname">{{menuItem.micName}}</div>
                    <div class="mealdesc" *ngIf="menuItem.micGuestDescription!=undefined">
                        -{{menuItem.micGuestDescription}}</div>
                </ng-container>
                <ng-container *ngIf="!isEmployeeOrCrewMember">
                    <div *ngFor="let guest of bookedGuests; let j=index;">
                        <ng-container>
                            <input type="checkbox"
                                [formControl]="$any(mealSelections).controls[j + 'dinnerApp' + menuItem.micuid]">
                            <span class="passenger-name">{{bookedGuests[j].folFullNameSal}}</span>


                        </ng-container>


                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
        <div class="tenpxtop"></div>
        <!-- Dinner Entree -->
        <ng-container *ngIf="!this.isLastDayOfCruise">
            <ng-container>
                <div class="mealtype">
                    <app-longgoldbar></app-longgoldbar>
                    <div>Dinner Entree</div>
                    <div><span class="mealtime">{{dinnerstarttime | timepipe}} - {{dinnerendtime |
                            timepipe}}</span></div>

                </div>
            </ng-container>
            <ng-container *ngFor="let menuItem of DinnerEntreeMenuItems; let i=index;">
                <ng-container>
                    <div class="tenpxtop"></div>
                    <div class="mealname">{{menuItem.micName}}</div>
                    <div class="mealdesc" *ngIf="menuItem.micGuestDescription!=undefined">
                        -{{menuItem.micGuestDescription}}</div>
                </ng-container>
                <ng-container *ngIf="!isEmployeeOrCrewMember">
                    <div *ngFor="let guest of bookedGuests; let j=index;">
                        <ng-container>
                            <input type="checkbox"
                                [formControl]="$any(mealSelections).controls[j + 'dinnerEntree' + menuItem.micuid]">
                            <span class="passenger-name">{{bookedGuests[j].folFullNameSal}}</span>

                            <div *ngIf="mealSelections.controls[j + 'dinnerEntree' + menuItem.micuid].value === true"
                                class="half-portion">
                                <input type="checkbox"
                                    [formControl]="$any(mealSelections).controls[j + 'dinnerEntree' + menuItem.micuid + 'HalfPortion']">
                                <span class="selection-text" [ngClass]="{'disabled': mealSelections.disabled}">1/2
                                    Portion
                                    entr&eacute;e</span>
                            </div>
                        </ng-container>


                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
        <div class="tenpxtop"></div>
        <app-longgoldbar></app-longgoldbar>
        <!-- DIETARY REQUIREMENTS -->
        <div *ngIf="(!isEmployeeOrCrewMember) || (mealCardsContainDietRequirements)" class="diet-text">I have special
            dietary requirements.</div>
        <div *ngFor="let guest of bookedGuests; let j=index;">
            <ng-container>
                <input type="checkbox" [formControl]="$any(mealSelections).controls[j + 'dietRequirements']">
                <span class="passenger-name"
                    [ngClass]="{'disabled': mealSelections.disabled}">{{bookedGuests[j].folFullNameSal}}</span>
                <div *ngIf="mealSelections.controls[j + 'dietRequirements'].value === true"
                    class="diet-restrictions-field">
                    <div class="row g-0">
                        <div class="col-1"></div>
                        <div class="col-10">
                            <textarea class="diet-restrictions-textarea"
                                [ngClass]="{'disabled': mealSelections.disabled}" maxLength="1000" rows="3"
                                placeholder="Please enter your dietary requirements."
                                [formControl]="$any(mealSelections).controls[j + 'dietRequirementsComments']"
                                [readonly]="mealSelections.disabled"
                                (focus)="onDietTextareaFocus($event)"
                                (blur)="onDietTextareaBlur()">
                            </textarea>
                            <span class="diet-restrictions-counter"
                                [ngClass]="{'disabled': mealSelections.disabled}">{{mealSelections.controls[j +
                                'dietRequirementsComments'].value.length}} / 1000</span>
                        </div>
                    </div>
                </div>
            </ng-container>


        </div>

        <div class="twentypxtop"></div>
        <!-- <div *ngIf="!isPastCuttoffWindow && !isEmployeeOrCrewMember" class="btn-container">
            <button class="btn btn-light floating" (click)="submitMealSelectionsForm()">Submit</button>
        </div> -->
    </div>

    <div class="tenpxtop"></div>
    <div class="disclaimer">
        *Items marked with an asterisk may be served raw or undercooked.
        Consuming raw or undercooked meats, poultry, seafood, shellfish, or eggs may increase your risk of foodborne
        illness,
        especially if you have certain medical conditions.
        <br><br>
        Please advise your server of any food allergies. Our food may have come in contact or contain peanuts, tree
        nuts, soy, milk, eggs, wheat, shellfish, sesame, or fish.
    </div>
    <div *ngIf="!isPastCuttoffWindow && !isEmployeeOrCrewMember" class="btn-container meal-submit-bottom">
        <button class="btn btn-light" (click)="submitMealSelectionsForm()"
            [disabled]="mealSelections.pristine">Submit</button>
    </div>
    <div class="tenpxtop"></div>
</div>
